// @ts-nocheck
import {EventBus} from "../../../../common/ts/events/EventBus";
import {ConsentChangedEvent, ConsentManagementInitializedEvent} from "./events";
import eventHandlers from "./eventHandlers";
import {GOOGLE_COOKIES_ENABLED_LOCAL_STORAGE_KEY} from "./constants";
import {ShowGoogleOneTapRequestedEvent} from "../googleOneTap/events";

const GOOGLE_ADS_VENDOR_ID = 'google';

let eventBus;

function init(ev = EventBus.getInstance()) {
    eventBus = ev;
    eventHandlers.init();
    window.didomiEventListeners = window.didomiEventListeners || [];
    window.didomiEventListeners.push({
        event: 'consent.changed',
        listener: function (context) {
            const cookiesObject = extractCookieObjectFrom(context);
            eventBus.emit(new ConsentChangedEvent({
                    googleCookiesEnabled: googleCookiesEnabled(cookiesObject)
                }
            ))
            eventBus.emit(new ShowGoogleOneTapRequestedEvent())
        }
    });

    eventBus.emit(new ConsentManagementInitializedEvent({
        googleCookiesEnabled: localStorage.getItem(GOOGLE_COOKIES_ENABLED_LOCAL_STORAGE_KEY) !== 'disabled'
    }))
}

function extractCookieObjectFrom(context) {
    return context.consentToken.consents.find((item) => item.purpose == 'cookies');
}

function googleCookiesEnabled(cookiesObject) {
    return !!cookiesObject.vendors
        .find((item) => item.id == GOOGLE_ADS_VENDOR_ID)?.status;
}

export default {
    init,
}
